<template>
  <div id="scorechart">
    <apexchart :options="options" :series="series" :height="height">
    </apexchart>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { GETTERS } from "@/store";

export default {
  name: "TheScoreChart",
  components: {},
  props: {
    height: { type: Number, default: 650 },
    width: { type: Number, default: 900 },
  },
  data: () => ({}),

  computed: {
    ...mapGetters({
      cards: GETTERS.CARDS,
      comparedData: GETTERS.COMPARED_CARDS_DATA,
    }),
    series() {
      const max = [10, 50, 10, 20, 30, 10];
      const value = (idx, value) => Math.round((value / max[idx]) * 100);

      return this.comparedData.map((item) => ({
        name: item.name,
        data: [
          value(0, item.testScore || 0),
          value(1, item.chapterOneScore || 0),
          value(2, item.financingScore || 0),
          value(3, item.targetScore || 0),
          value(4, item.legalProtectionScore || 0),
          value(5, item.chapterTwoScore || 0),
        ],
      }));
    },

    options() {
      return {
        chart: {
          id: "scorechart",
          type: "radar",
          height: this.height,
        },
        xaxis: {
          categories: [
            "Доказательная база",
            "Научно-технический уровень",
            "Объем инвестиций",
            "Приоритетность",
            "Защищенность прав",
            ["Опыт практического применения", " (оценка эксперта)"],
          ],
          labels: {
            show: true,
            style: {
              colors: ["#0", "#0", "#0", "#0", "#0", "#0"],
            },
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          labels: {
            formatter: (value) => {
              return value + " %";
            },
          },
        },
        stroke: { width: 2 },
        fill: { opacity: 0.2 },
        markers: { size: 6 },
        dataLabels: {
          enabled: false,
        },
        legend: {
          position: "right",
          horizontalAlign: "left",
          onItemHover: {
            highlightDataSeries: true,
          },

          formatter: (seriesName) => {
            const len = 60;
            return seriesName.length < len
              ? seriesName
              : `${seriesName.slice(0, len)}...`;
          },
          showForSingleSeries: this.series.length > 0,
        },
        plotOptions: {
          radar: {
            polygons: {
              strokeColors: "#e9e9e9",
              fill: {
                colors: ["#f8f8f8", "#fff"],
              },
            },
          },
        },
      };
    },

    chartWidth() {
      return this.width - this.margin.left - this.margin.right;
    },
    chartHeight() {
      return this.height - this.margin.bottom - this.margin.top;
    },
  },
};
</script>
